export const isArray = (obj) => Boolean(isObject(obj) && obj instanceof Array);

export const isEmptyArray = (obj) => Boolean(isArray(obj) && obj.length === 0);

export const isNonEmptyArray = (arr) => Array.isArray(arr) && arr.length > 0;

export const isObject = (obj) => Boolean(obj && typeof obj === 'object');

export const isNonEmptyObject = (obj) => obj && Object.keys(obj).length > 0;

export const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;

export const isNonEmptySet = (set) => set && set.size > 0;

export const isBoolean = (val) => typeof val === 'boolean';

export const isEmpty = (value) =>
    value === undefined || value === null || value === '';

export const isNonEmptyString = (str) => typeof str === 'string' && str?.trim().length > 0;

export const isEmptyString = (str) => Boolean(typeof str === 'string' && str.length === 0);

export const getNonEmptyString = (data) => {
    if (isNonEmptyString(data)) return data;

    return '';
};

export const isUndefinedOrNull = (value) => value === null || value === undefined;

export const negativeNumberCheck = (event) => {
    if (event.key === '-') 
      event.preventDefault();
}


export function scrollToRow(rowId, delay = 1500) {
  if (!rowId) return;

  setTimeout(() => {
    const rowEl = document.querySelector(`[data-row-id='${rowId}']`);
    if (rowEl) {
      rowEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }, delay);
}